<template>
  <div class="user-info-container">
    <div class="user-card">
      <h2>用户信息</h2>

      <div class="user-details">
        <div class="info-item">
          <span class="label">用户名：</span>
          <span class="value">{{ userInfo.username }}</span>
        </div>
        <div class="info-item">
          <span class="label">角色：</span>
          <span class="value">{{ userInfo.role }}</span>
        </div>
        <div class="info-item">
          <span class="label">状态：</span>
          <span class="value">{{ userInfo.status === 'ACTIVE' ? '正常' : '禁用' }}</span>
        </div>
        <div class="info-item">
          <span class="label">用户分类：</span>
          <span class="value">{{ userInfo.category || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="label">采购单位：</span>
          <span class="value">{{ userInfo.purchasingUnits }}</span>
        </div>
        <div class="info-item">
          <span class="label">创建时间：</span>
          <span class="value">{{ formatDate(userInfo.createAt) }}</span>
        </div>
      </div>

      <!-- 修改密码表单 -->
      <div class="password-change-section">
        <h3>修改密码</h3>

        <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-position="top" class="password-form">
          <el-form-item label="当前密码" prop="currentPassword">
            <el-input type="password" v-model="passwordForm.currentPassword" show-password></el-input>
          </el-form-item>

          <el-form-item label="新密码" prop="newPassword">
            <el-input type="password" v-model="passwordForm.newPassword" show-password></el-input>
          </el-form-item>

          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input type="password" v-model="passwordForm.confirmPassword" show-password></el-input>
          </el-form-item>

          <div class="form-buttons">
            <el-button type="primary" @click="submitPasswordChange" :loading="loading" class="submit-btn">提交修改</el-button>
            <el-button @click="resetForm" class="reset-btn">重置</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { ElMessage } from 'element-plus';
import { redirectToLogin } from '@/utils/authRedirect';

export default {
  name: 'UserInfo',
  data() {
    // 密码确认验证
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      userInfo: {
        userId: '',
        username: '',
        role: '',
        category: '',
        purchasingUnits: '',
        status: '',
        createAt: '',
        updateAt: ''
      },
      passwordForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        currentPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      loading: false
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (userInfo) {
        this.userInfo = userInfo;
      } else {
        redirectToLogin(this.$router, {
          message: '获取用户信息失败，请重新登录'
        });
      }
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
    },

    // 提交密码修改
    submitPasswordChange() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.loading = true;

          // 确保用户ID是数字类型
          const userId = parseInt(this.userInfo.userId);
          console.log('提交密码修改请求，用户ID:', userId);

          axios.post('/api/v1/user/changePassword', {
            userId: userId,
            currentPassword: this.passwordForm.currentPassword,
            newPassword: this.passwordForm.newPassword
          })
              .then(response => {
                console.log('密码修改响应:', response.data);
                const resp = response.data;
                if (resp.code === '200') {
                  ElMessage.success('密码修改成功');
                  // 清空表单
                  this.resetForm();
                } else {
                  ElMessage.error(resp.info || '密码修改失败');
                }
              })
              .catch(error => {
                console.error('修改密码出错:', error);
                ElMessage.error('服务器错误，请稍后重试');
              })
              .finally(() => {
                this.loading = false;
              });
        } else {
          return false;
        }
      });
    },
    
    // 重置表单
    resetForm() {
      this.$refs.passwordForm.resetFields();
    }
  }
};
</script>

<style scoped>
.user-info-container {
  display: flex;
  justify-content: center;
  padding: 20px;
  margin-top: 60px; /* 为固定的导航栏留出空间 */
  box-sizing: border-box;
  width: 100%;
}

.user-card {
  width: 100%;
  max-width: 600px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: all 0.3s ease;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #409EFF;
  font-size: 24px;
}

h3 {
  margin-top: 25px;
  margin-bottom: 15px;
  color: #606266;
  font-size: 18px;
}

.user-details {
  margin-bottom: 30px;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 15px;
  background-color: #F5F7FA;
  transition: all 0.3s ease;
}

.info-item {
  margin-bottom: 10px;
  display: flex;
  transition: all 0.3s ease;
}

.label {
  font-weight: bold;
  width: 100px;
  flex-shrink: 0; /* 防止在小屏幕上缩小 */
}

.value {
  flex: 1;
  word-break: break-all; /* 确保长文本能够正确换行 */
}

.password-change-section {
  border-top: 1px solid #EBEEF5;
  padding-top: 20px;
  margin-top: 20px;
}

.password-form {
  max-width: 100%;
}

.form-buttons {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  gap: 20px;
}

/* 覆盖Element Plus的按钮间距样式 */
:deep(.el-button + .el-button) {
  margin-left: 0;
}

.submit-btn, .reset-btn {
  min-width: 120px;
  height: 40px;
  font-size: 14px;
  border-radius: 4px;
  margin: 0; /* 确保按钮没有外边距 */
}

.submit-btn {
  background-color: #409EFF;
}

.reset-btn {
  border: 1px solid #DCDFE6;
  color: #606266;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .user-info-container {
    padding: 15px 10px;
  }

  .user-card {
    padding: 15px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
  }

  .info-item {
    flex-direction: column;
    margin-bottom: 15px;
  }

  .label {
    width: 100%;
    margin-bottom: 5px;
  }

  .value {
    width: 100%;
  }

  h2 {
    font-size: 1.5rem;
  }

  h3 {
    font-size: 1.2rem;
  }

  /* Element Plus表单适配 */
  :deep(.el-form-item__label) {
    padding: 0 0 8px;
    line-height: 1.2;
    text-align: left;
  }

  :deep(.el-form-item) {
    margin-bottom: 18px;
  }

  :deep(.el-form) {
    padding: 0 5px;
  }
  
  /* 表单按钮在移动端占满宽度 */
  .form-buttons {
    flex-direction: column;
    gap: 12px;
    width: 100%;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .submit-btn, .reset-btn {
    width: 100%;
    margin: 0;
  }
  
  /* 确保在移动端也覆盖Element Plus的按钮样式 */
  :deep(.el-button) {
    margin: 0;
    display: block;
    width: 100%;
  }
  
  /* 确保密码输入框在移动端有足够的点击区域 */
  :deep(.el-input__inner) {
    height: 40px;
    font-size: 16px; /* 移动端上推荐的最小字体大小，避免iOS自动缩放 */
  }
}

/* 更小屏幕的适配 */
@media (max-width: 480px) {
  .user-info-container {
    padding: 10px 5px;
  }
  
  .user-card {
    padding: 12px;
  }
  
  h2 {
    font-size: 1.3rem;
    margin-bottom: 15px;
  }
  
  h3 {
    font-size: 1.1rem;
    margin-top: 20px;
    margin-bottom: 12px;
  }
  
  .user-details {
    padding: 10px;
    margin-bottom: 20px;
  }
  
  /* 调整表单标签宽度 */
  :deep(.el-form-item__label) {
    font-size: 14px;
  }
  
  /* 调整表单输入框内边距 */
  :deep(.el-input__inner) {
    padding: 0 10px;
  }
}
</style> 
